<template>
  <div class="vx-card">
    <div class="vx-card__header">
      <div class="vx-card__title">
        <h4>Información de Contacto</h4>
      </div>
    </div>
    <div class="vx-card__collapsible-content vs-con-loading__container">
      <div class="vx-card__body">

        <form-wizard color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" finishButtonText="Submit" @on-complete="addContactRespond" :disabled="isSubmitting">
          <tab-content title="Step 1" class="mb-5" icon="feather icon-user" :before-change="validateStep1">
            
            <form data-vv-scope="step-1">
              <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <vs-input class="w-full" icon-pack="feather" icon="icon-user" icon-no-border label="Nombre" name="name" v-model="iname" v-validate="'required|alpha|max:50'"/>
                  <span class="text-danger text-sm">{{ errors.first('name', 'step-1') }}</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <vs-input class="w-full" icon-pack="feather" icon="icon-user" icon-no-border label="Apellido" name="lastname" v-model="ilastname" v-validate="'required|alpha|max:50'"/>
                  <span class="text-danger text-sm">{{ errors.first('lastname', 'step-1') }}</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <vs-input class="w-full" icon-pack="feather" icon="icon-smartphone" icon-no-border label="Teléfono Celular" name="phone" v-model="icellphone" v-validate="'required|max:18'"/>
                  <span class="text-danger text-sm">{{ errors.first('phone', 'step-1') }}</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <vs-input class="w-full" icon-pack="feather" icon="icon-credit-card" icon-no-border label="Identificación" name="dni" v-model="idni" v-validate="'required|alpha_num|max:15'"/>
                  <span class="text-danger text-sm">{{ errors.first('dni', 'step-1') }}</span>
                </div>
              </div>
            </form>
          </tab-content>

          <tab-content title="Step 2" class="mb-5" icon="feather icon-home" :before-change="validateStep2">
            <form data-vv-scope="step-2">
              <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <vs-input class="w-full" icon-pack="feather" icon="icon-user" icon-no-border name="email" label="Correo" v-model="iemail" v-validate="'required|email'"/>
                  <span class="text-danger text-sm">{{ errors.first('email', 'step-2') }}</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <vue-simple-suggest class="w-full" v-model="icountry" :list="loadCountriesOptions" :filter-by-query="true" name="countries">
                    <vs-input class="w-full" icon-pack="feather" icon="icon-globe" name="country" icon-no-border label="País" v-model="icountry" v-validate="'required'"/>
                  </vue-simple-suggest>
                  <span class="text-danger text-sm">{{ errors.first('country', 'step-2') }}</span>
                </div>
                <div class="vx-col md:w-full w-full">
                  <label>Dirección</label>
                  <vs-textarea v-model="iaddress" label="Dirección" class="mb-0 md:mt-2 mt-6" name="address" rows="3" v-validate="'required|max:150'"/>
                  <span class="text-danger text-sm">{{ errors.first('address', 'step-2') }}</span>
                </div>
              </div>
            </form>
          </tab-content>

          <tab-content title="Step 3" class="mb-5" icon="feather icon-dollar-sign" :before-change="validateStep3">
            <form data-vv-scope="step-3">
              <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <vs-input class="w-full" type="number" icon-pack="feather" icon="icon-dollar-sign" id="totaldebt" name="Total_Debt" icon-no-border label="Total Deuda" v-model="itotaldebt" v-validate="'required|decimal:2'"/>
                  <span class="text-danger text-sm">{{ errors.first('Total_Debt', 'step-3') }}</span>
                </div>
                <!-- <div class="vx-col sm:w-1/2 w-full mb-2">
                  <vue-simple-suggest
                    class="w-full"
                    v-model="ifinanentity"
                    :list="loadFinEntOptions"
                    :filter-by-query="true"
                    name="finEntitiesOptions"
                  >
                    <vs-input
                      class="w-full"
                      icon-pack="feather"
                      icon="icon-users"
                      icon-no-border
                      label-placeholder="Entidad Financiera"
                      v-model="ifinanentity"
                    />
                  </vue-simple-suggest>
                </div> -->
                <div class="vx-col md:w-1/2 w-full">
                  <!-- <label class="vs-input--label">Entidad Financiera</label> -->
                  <!--<v-select v-model="ifinanentity" :clearable="false" :options="finOpts" name="finent" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select> -->
                  <vs-select v-model="ifinanentity" class="w-full select-large" name="Finantial_Entity" label="Entidad Financiera" v-validate="'required'">
                    <vs-select-item :key="index" :value="item.fin_name" :text="item.fin_name" v-for="(item, index) in finOpts" class="w-full" />
                  </vs-select>
                  <span class="text-danger text-sm">{{ errors.first('Finantial_Entity', 'step-3') }}</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <vue-simple-suggest class="w-full" v-model="icreditcard" :list="loadFinEntCreditCardsOptions" :filter-by-query="true" >
                    <vs-input class="w-full" icon-pack="feather" icon="icon-credit-card" icon-no-border label="Tarjeta Crédito" name="Credit_Card" v-model="icreditcard" v-validate="'required'"/>
                  </vue-simple-suggest>
                  <span class="text-danger text-sm">{{ errors.first('Credit_Card', 'step-3') }}</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2 mt-1">
                  <label class="text-sm">Enviar Template</label>
                  <div class="mt-2">
                    <vs-radio v-model="send" vs-value="1" class="mr-4">Si</vs-radio>
                    <vs-radio v-model="send" vs-value="0" class="mr-4">No</vs-radio>
                  </div>
                </div>
              </div>
            </form>
          </tab-content>
        </form-wizard>
      </div>
    </div>
  </div>
</template>

<script>
import VueSimpleSuggest from 'vue-simple-suggest'
import vSelect from 'vue-select'
import 'sweetalert2/dist/sweetalert2.min.css'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css' 

export default {
  data () {
    return {
      iname: '',
      ilastname: '',
      icellphone: '',
      iemail: '',
      idni: '',
      iaddress: '',
      icountry: '',
      itotaldebt: '',
      ifinanentity: '',
      icreditcard: '',
      isSubmitting: false,
      finOpts:'',
      send: '1'
    }
  },
  mounted () {
    this.loadFinEntOptions()
  },
  components: {
    vSelect,
    FormWizard,
    TabContent,
    VueSimpleSuggest
  },
  methods: {
    validateStep1 () {
      return new Promise((resolve, reject) => {
        console.log('Entra')
        this.$validator.validateAll('step-1').then(result => {
          if (result) {
            console.log('aqui')
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-2").then(result => {
          if (result) {
            resolve(true)
          } else {
            reject("correct all values");
          }
        })
      })
    },
    validateStep3() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-3").then(result => {
          if (result) {
            //alert("Form submitted!");
            resolve(true)
          } else {
            this.showAlert('Existen errores en el formulario!')
          }
        })
      })
    },
    async addContactRespond () {
      this.isSubmitting = true
      const { data } = await this.$http.post(
        `${process.env.apiRobocob}/api/addContact`,
        {
          firstName: this.iname,
          lastName: this.ilastname,
          phone: this.icellphone,
          dni: this.idni,
          email: this.iemail,
          pais: this.icountry,
          direccion: this.iaddress,
          totalDeuda: this.itotaldebt,
          entidadFin: this.ifinanentity,
          tarjetaCredito: this.icreditcard,
          sendTemplate: this.send
        }
      )
      
      if(data.status == 1){
        this.showAlert(data.message)
        /* this.iname = ''
        this.ilastname = ''
        this.icellphone = ''
        this.idni = ''
        this.iemail = ''
        this.icountry = ''
        this.iaddress = ''
        this.itotaldebt = ''
        this.ifinanentity = ''
        this.icreditcard = '' */
        //this.$router.go()
      }else{
        this.showAlert(data.message)
      }
    },
    showAlert (message) {
      this.$swal(message)
      this.isSubmitting = false
    },
    async loadCountriesOptions () {
      const { data } = await this.$http.get(`${process.env.apiRobocob}/api/getCountries`)
      return data
    },
    async loadFinEntOptions () {
      const { data } = await this.$http.get(`${process.env.apiRobocob}/api/getFinantialEntities`)
      //console.log(data)
      this.finOpts = data
      this.ifinanentity = this.finOpts[3].fin_name
      return data
    },
    async loadFinEntCreditCardsOptions () {
      if (this.ifinanentity) {
        const { data } = await this.$http.get(`${process.env.apiRobocob}/api/getCreditCardsByFinEntity/${this.ifinanentity}`)
        return data
      } else {
        this.showAlert('¡Primero debe seleccionar una Entidad Financiera!')
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/autocomplete.scss"
</style>
